<template>
    <div class="wrapper">
        <div class="register page site-top-padding ">
            <div v-if="mode === 'resetPassword'">
                <h1>Password Reset</h1>
                <div class="row stack">
                    <p>Enter your new password.</p>
                </div>
                <div class="row stack">
                    <label>Password</label>
                    <input type="password" v-model="password" required>
                </div>
                
                <button class="btn big" @click="validatePasswordReset">RESET PASSWORD</button>
            </div>

            <div v-if="mode === 'verifyEmail'">
                <h1>Verifying Email...</h1>
            </div>
            
        </div>
    </div>
</template>
<script>
    import firebase from 'firebase/app';

    export default {
        name: "register",
        data: () => ({
            email: '',
            mode: undefined,
            oobCode: '',
            password: ''
        }),
        beforeMount () {
            // get params
            this.mode = this.$route.query.mode;
            this.oobCode = this.$route.query.oobCode;
            if (this.mode !== 'resetPassword' && this.mode !== 'verifyEmail') {
                this.$router.replace('/')
            }
        },
        mounted () {
            this.emailVerify()
        },
        methods: {
            resetPassword () {
                firebase
                    .auth()
                    .confirmPasswordReset(this.oobCode, this.password)
                    .then(() => {
                        this.$router.replace('login')
                    }).catch( error => {
                        window.alert(error)
                    })
            },
            
            validatePasswordReset () {
                if (this.password !== "") {
                    this.resetPassword();
                }
            },
            emailVerify () {
                firebase
                    .auth()
                    // .confirmPasswordReset(Cthis.oobCode, this.password)
                    .applyActionCode(this.oobCode)
                    .then( () => {
                        // window.alert('Password reset email sent, check your inbox.');
                        // console.log(resp)
                        // go login
                        this.$router.replace('login')
                    }).catch( error => {
                        window.alert(error)
                    })
            }
        }
    }
</script>

<style scoped lang="scss">

    @import "../scss/vars";
    @import "../scss/wrapper";
    @import "../scss/forms";

    .site-top-padding{
        margin-top: 8rem;
    }
</style>